import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialCalloutsByObjective,
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import ReachModule from 'components/organisms/social/ReachModule';
import ReachExpandContainer, { BrandAwarnessExpandContainer } from 'containers/dashboards/social/ReachExpandContainer';

class ReachContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'REACH' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialCalloutsByObjective(payload);
    }

    render() {
        return (
            <ReachModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                ExpandContainer={ReachExpandContainer}
                layer={this.props.layer}
            />
        );
    }
}

const mapDispatchPops = {
    fetchSocialCalloutsByObjective,
};

const mapReachStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.REACH,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapReachStateToProps, mapDispatchPops)(ReachContainer);


class BrandAwarness extends ReachContainer {
    constructor(props) {
        super(props, { objective: 'BRAND_AWARENESS' });
    }

    render() {
        return (
            <ReachModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                ExpandContainer={BrandAwarnessExpandContainer}
                layer={this.props.layer}
            />
        );
    }
}

const mapBrandAwarnessStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.BRAND_AWARENESS,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export const BrandAwarnessContainer = connect(mapBrandAwarnessStateToProps, mapDispatchPops)(BrandAwarness);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/ReachContainer.js